import { apiExternal, IApiResponse, IFixResponse } from 'api';

export type TCep = `${number}${number}${number}${number}${number}-${number}${number}${number}`;

interface ICommomFilters {
  cod_parque_servico: number;
  count?: number;
}

interface IFiltrosBuscaPorEndereco extends ICommomFilters {
  address: string;
}

interface IFiltrosBuscaPorCep extends ICommomFilters {
  postalCode: TCep;
}

interface IFiltrosBuscaPorLatLng extends ICommomFilters {
  latitude: number;
  longitude: number;
}

type IFiltros = IFiltrosBuscaPorEndereco | IFiltrosBuscaPorLatLng | IFiltrosBuscaPorCep;

export type AreaColetaBuscada = {
  seq_area_coleta: number;
  nom_area_coleta: string;
  area_json: any;
  position: {
    latitude: number;
    longitude: number;
    endereco?: string;
  };
  area_coleta_horario: {
    num_dia_semana: number;
    num_hora_inicial: string;
    num_hora_final: string;
  }[];
};

export async function getAreaColetaParquePorPosicao(filtros: IFiltros): Promise<IFixResponse<AreaColetaBuscada>> {
  const res: IApiResponse = await apiExternal.get(
    `/external/parqueservico/area-coleta/buscar-por-endereco-ou-posicao`,
    { params: filtros },
  );

  if (res.failed) {
    if (res.message) {
      return { err: res.message, data: null };
    }
    return { err: res.err, data: null };
  }

  const { data } = res;
  return { err: null, resp: data };
}
